import { useEffect, useState } from "react";
import AppConst from "../apis/appconst";
import axios from "axios";
function NewSaleReturn() {
    const [ldata, setLdata] = useState(null);
    const [formData, setFormData] = useState({
        medicines: [
            {
                sn: 1,
                store_purchase_item_name: '',
                store_purchase_item_unit: '',
                store_purchase_item_rate: '',
                store_purchase_item_qty: '',
                store_purchase_item_dis: '',
                store_purchase_item_dis_amt: '',
                store_purchase_item_gst: '',
                store_purchase_item_total: '',
                store_purchase_item_gtotal:''
            }
        ],
        store_purchase_type:'storesalereturn',
        store_purchase_id: '',
        store_purchase_no: '',
        store_purchase_date: '',
        store_purchase_mode: '',
        store_invoice_number: '',
        store_invoice_date: '',
        store_purchase_vendor: '',
        store_purchase_total: '',
        store_purchase_gtotal:'',
        store_purchase_return_reason:'',
        store_purchase_dis: '',
        store_purchase_gst: '',
        store_purchase_user: '',
        page_no: 0,
        alertMsg: '',
        alertMsgTyp: '',
        search_key: '',
        isAlert: false,
    });

    const handleChange = (e) => {

        const { name, value } = e.target;
        setFormData(prev => ({
            ...prev,
            [name]: value
        }));
        if ((name + "").localeCompare("search_key") == 0) {
            initData();
        }
    };

    const handleChange1 = (e,index) => {
        if (!e || !e.target) return;
        const { name, value } = e.target;
        // alert(name+"");
        const name1 = name.replace(/[0-9]/g, "");

        // alert(name1+"");
        setFormData(prev => {
            const updatedItems = [...prev.medicines];
            updatedItems[index] = {
              ...updatedItems[index],
              [name1]: value
            };
        
            return {
              ...prev,
              medicines: updatedItems
            };
          });
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        // alert(formData.email+"");
        const fd = new FormData();

        // purchase_type
        fd.append('store_purchase_id', formData.store_purchase_id);
        fd.append('store_purchase_no', formData.store_purchase_no);
        fd.append('store_purchase_type', formData.store_purchase_type);
        fd.append('store_purchase_date', formData.store_purchase_date);
        fd.append('store_purchase_mode', formData.store_purchase_mode);
        fd.append('store_invoice_number', formData.store_invoice_number);
        fd.append('store_invoice_date', formData.store_invoice_date);
        fd.append('store_purchase_vendor', formData.store_purchase_vendor);
        fd.append('store_purchase_total', formData.store_purchase_total);
        fd.append('store_purchase_dis', formData.store_purchase_dis);
        fd.append('store_purchase_gst', formData.store_purchase_gst);
        fd.append('store_purchase_gtotal', formData.store_purchase_gtotal);
        fd.append('store_purchase_return_reason', formData.store_purchase_return_reason);
        
        
        fd.append('store_items', JSON.stringify(formData.medicines) + "");
        fd.append('store_purchase_user', ldata.user_id);

        try {
            const response = await axios.post(AppConst.BASE_URL + AppConst.addStorePurchaseUrl, fd, {
                headers: {
                    'Content-Type': 'multipart/form-data',
                },
            });

            if (response.data.status) {
                setFormData(prev => ({
                    ...prev,
                    isAlert: true,
                    alertMsg: response.data.success,
                    alertMsgTyp: response.data.type,
                }));
                sessionStorage.removeItem("opd_dt")
                window.location.href = "/sale_return1";
            }
            else {
                setFormData(prev => ({
                    ...prev,
                    isAlert: true,
                    alertMsg: response.data.success,
                    alertMsgTyp: response.data.type,
                }));
            }
        } catch (error) {
            setFormData(prev => ({
                ...prev,
                isAlert: true,
                alertMsg: "Failed",
                alertMsgTyp: "danger",
            }));
        }

    };

    const initData = async () => {
        const storedData = sessionStorage.getItem("ldata");
        if (storedData) {
            const parsed = JSON.parse(storedData);
            var fd = new FormData();
            fd.append('page_no', "0");
            fd.append('search_key', formData.search_key + "");
            fd.append('test_user', 1 + "");
            try {
                const response = await axios.post(AppConst.BASE_URL + AppConst.getTestListUrl, fd, {
                    headers: {
                        'Content-Type': 'multipart/form-data',
                    },
                });
                if (response.data.status) {

                    var records = response.data.records;
                    if (records != null && records != undefined) {
                        setFormData(prev => ({
                            ...prev,
                            tests: records
                        }));
                        if (formData.items.length <= 0) {
                            setFormData(prev => ({
                                ...prev,
                                items: records
                            }));
                        }
                    }
                }
            } catch (error) {

            }

            fd = new FormData();
            fd.append('cat_type', "vital");
            fd.append('page_no', "none");
            fd.append('search_key', "");
            fd.append('par_by', 1 + "");
            try {
                const response = await axios.post(AppConst.BASE_URL + AppConst.getCatListUrl, fd, {
                    headers: {
                        'Content-Type': 'multipart/form-data',
                    },
                });
                if (response.data.status) {

                    var records = response.data.records;
                    if (records != null && records != undefined) {
                        setFormData(prev => ({
                            ...prev,
                            vitals: records
                        }));
                    }
                }
            } catch (error) {

            }
        }
    };

    useEffect(() => {
        console.log('Component mounted');
        const storedData = sessionStorage.getItem("ldata");
        if (storedData) {
            const parsed = JSON.parse(storedData);
            setLdata(parsed);
            initData();
        }

        if (
            sessionStorage.getItem("opd_dt") != null &&
            sessionStorage.getItem("opd_dt") != undefined &&
            sessionStorage.getItem("opd_dt").length > 0
        ) {
            var tmp = JSON.parse(sessionStorage.getItem("opd_dt") + "");
            if (tmp != null && tmp != undefined) {

                var items = tmp.items;

                setFormData(prev => ({
                    ...prev,
                    medicines:items,
                    store_purchase_id: tmp.store_purchase_id,
                    store_purchase_no: tmp.store_purchase_no,
                    store_purchase_type: tmp.store_purchase_type,
                    store_purchase_date: tmp.store_purchase_date,
                    store_purchase_mode: tmp.store_purchase_mode,
                    store_invoice_number: tmp.store_invoice_number,
                    store_invoice_date: tmp.store_invoice_date,
                    store_purchase_vendor: tmp.store_purchase_vendor,
                    store_purchase_total: tmp.store_purchase_total,
                    store_purchase_dis: tmp.store_purchase_dis,
                    store_purchase_gst: tmp.store_purchase_gst,
                    store_purchase_gtotal: tmp.store_purchase_gtotal,
                    store_purchase_return_reason: tmp.store_purchase_return_reason,
                    store_purchase_user: tmp.store_purchase_user,
                }));
            }
        }



        return () => {
            console.log('Component unmounted');
        };
    }, []);
    return (
        <div class="page-content">
            <div class="container-fluid">
                <div class="row">
                    <div class="col-xxl-12">
                        <div class="card">
                            <div class="card-body">
                                <h5>New Sale Return</h5>
                                <br />
                                <div class="live-preview">
                                    <form onSubmit={handleSubmit}>
                                        <div class="row">

                                            <div class="col-md-4">
                                                <div >
                                                    <label for="customername-field" class="form-label">Return No.</label>
                                                    <input name="store_purchase_no" onChange={handleChange} value={formData.store_purchase_no} class="form-control" placeholder="Enter Return No." type="text" />
                                                </div>
                                            </div>
                                            <div class="col-md-4">
                                                <div >
                                                    <label for="customername-field" class="form-label">Return Date</label>
                                                    <input name="store_purchase_date" onChange={handleChange} value={formData.store_purchase_date} 
                                                    class="form-control" placeholder="Enter Return Date"
                                                        type="date" />
                                                </div>
                                            </div>
                                            <div class="col-md-4">
                                                <div >
                                                    <label for="customername-field" class="form-label">Department</label>
                                                    <input name="store_invoice_number" onChange={handleChange} value={formData.store_invoice_number} class="form-control" placeholder="Enter Department" type="text" />
                                                </div>
                                            </div>
                                            <div class="col-md-4">
                                                <div >
                                                    <label for="customername-field" class="form-label">Select Doctor</label>
                                                    <select class="form-control"  name="store_purchase_vendor" onChange={handleChange} value={formData.store_purchase_vendor}>
                                                    <option value="" selected>Select</option>
                                                        
                                                        <option value="Ven 1">Ven 1</option>
                                                        <option value="Ven 2">Ven 2</option>

                                                    </select>
                                                </div>
                                            </div>

                                            <div class="col-lg-12">
                                                <br />
                                                <div class="row">
                                                    <div class="col-lg-8">
                                                        <h6>Items</h6>
                                                    </div>
                                                    <div class="col-lg-4" style={{ textAlign: "right" }}>
                                                        <button type="button"
                                                         onClick={(e) => {
                                                            e.preventDefault();
                                                            var tmp = formData.medicines;
                                                            tmp.push({
                                                                sn: (tmp.length + 1),
                                                                store_purchase_item_name: '',
                                                                store_purchase_item_unit: '',
                                                                store_purchase_item_rate: '',
                                                                store_purchase_item_qty: '',
                                                                store_purchase_item_dis: '',
                                                                store_purchase_item_dis_amt: '',
                                                                store_purchase_item_gst: '',
                                                                store_purchase_item_total: '',
                                                            });

                                                            setFormData(prev => ({
                                                                ...prev,
                                                                medicines: tmp
                                                            }));

                                                        }}
                                                        class="btn btn-primary">Add</button>
                                                    </div>
                                                </div>
                                                <br />
                                            </div>
                                            <div class="col-md-12">
                                                <div class="card-body pt-0">
                                                    <div>

                                                        <div class="table-responsive table-card mb-1">
                                                            <table class="table table-nowrap align-middle" id="orderTable">
                                                                <thead class="text-muted table-light" >
                                                                    <tr class="text-uppercase">

                                                                        <th data-sort="customer_name">Sr. No.</th>
                                                                        <th data-sort="customer_name">Item Name</th>
                                                                        <th data-sort="customer_name">Unit</th>
                                                                        <th data-sort="customer_name">Return QTY</th>
                                                                        <th data-sort="customer_name">Amount</th>
                                                                    </tr>
                                                                </thead>
                                                                <tbody class="list form-check-all">
                                                                {formData.medicines.map((item, index) => (
                                                                    <tr>
                                                                        <td class="customer_name">{index+1}.</td>
                                                                        <td class="customer_name">
                                                                            <input type="text" class="form-control" name={'store_purchase_item_name'+index} 
                                                                                value={item.store_purchase_item_name} 
                                                                                onChange={(e) => handleChange1(e,index)} />
                                                                        </td>
                                                                        <td class="customer_name">
                                                                            <input type="text" class="form-control" name={'store_purchase_item_unit'+index} 
                                                                                value={item.store_purchase_item_unit} 
                                                                                onChange={(e) => handleChange1(e,index)} />
                                                                        </td>
                                                                        <td class="customer_name">
                                                                            <input type="text" class="form-control" name={'store_purchase_item_qty'+index} 
                                                                                value={item.store_purchase_item_qty} 
                                                                                onChange={(e) => handleChange1(e,index)} />
                                                                        </td>
                                                                       
                                                                        <td class="customer_name">
                                                                            <input type="text" class="form-control" name={'store_purchase_item_total'+index} 
                                                                                value={item.store_purchase_item_total} 
                                                                                onChange={(e) => handleChange1(e,index)} />
                                                                        </td>
                                                                    </tr>
                                                                    ))}
                                                                    <tr>
                                                                        <td class="customer_name" colspan="2"></td>
                                                                        <td class="customer_name"><strong>Total Return Qty</strong></td>
                                                                        <td class="customer_name"><strong>Amount</strong></td>
                                                                        <td class="customer_name"><strong>Reason</strong></td>
                                                                    </tr>
                                                                    <tr>
                                                                        <td class="customer_name" colspan="2"></td>
                                                                        <td class="customer_name">
                                                                            <input type="text" class="form-control" 
                                                                                name="store_purchase_dis" 
                                                                                value={formData.store_purchase_dis} 
                                                                                onChange={handleChange} />
                                                                        </td>
                                                                        
                                                                        <td class="customer_name">
                                                                            <input type="text" class="form-control" 
                                                                                name="store_purchase_gtotal" 
                                                                                value={formData.store_purchase_gtotal} 
                                                                                onChange={handleChange} />
                                                                        </td>
                                                                        <td class="customer_name">
                                                                            <input type="text" class="form-control" 
                                                                                name="store_purchase_return_reason" 
                                                                                value={formData.store_purchase_return_reason} 
                                                                                onChange={handleChange} />
                                                                        </td>
                                                                    </tr>
                                                                </tbody>

                                                            </table>
                                                        </div>

                                                    </div>
                                                </div>
                                            </div>

                                            <div class="col-lg-12">
                                                <div class="text-end">
                                                    <button type="submit" class="btn btn-primary">Save</button>
                                                </div>
                                            </div>
                                        </div>

                                    </form>
                                </div>

                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default NewSaleReturn;
